import React from "react";
import sectionImgDesktop from "../../images/Sec 04 Horizontal.webp";
import sectionImgMobile from "../../images/Section 04.webp";
import "../../styles/main.scss";

const steps = [
  {
    num: "01",
    icon: "📋",
    iconTheme: "navy",
    title: "You share a few simple daily salon numbers",
    tags: [
      { label: "Minimal Input", color: "navy" },
      { label: "No Accounting Knowledge Required", color: "navy" },
    ],
    desc: "You or your team share a few basic daily numbers from the salon. The process is designed to stay light, simple, and manageable — so it does not feel like extra work. You do not need accounting knowledge, complex tools, or a complicated setup to begin.",
  },
  {
    num: "02",
    icon: "📊",
    iconTheme: "gold",
    title: "We build your Weekly Munafa Intelligence Deck",
    tags: [
      { label: "Structured Clarity", color: "gold" },
      { label: "Profit, Leaks, Trends, Categories", color: "gold" },
    ],
    desc: "We clean, organise, and structure your salon's numbers into one clear weekly view. Then we turn them into your Weekly Munafa Intelligence Deck — a simple visual breakdown that helps you see weekly position, leak areas, expense pressure, category performance, and the patterns that deserve your attention.",
  },
  {
    num: "03",
    icon: "🎯",
    iconTheme: "navy",
    title: "You receive clear action points for the coming week",
    tags: [
      { label: "Practical Steps", color: "navy" },
      { label: "Weekly Direction", color: "navy" },
      { label: "Better Control", color: "navy" },
    ],
    desc: "Along with the deck, you receive a few practical action points based on your real numbers. These help you understand what needs fixing, what deserves closer attention, and what should be watched more carefully in the coming week — so your next decisions feel more clear, timely, and controlled, without guesswork and without confusion.",
  },
];

const Section04 = () => {
  return (
    <section id="how-it-works" className="section-04">
      {/* ── Top row ── */}
      <div className="section-04__top-row">
        <div className="section-04__content">
          <h2 className="section-04__title">
            How Your Salon&apos;s <br />
            Daily Numbers Turn Into <br />
            <span className="section-04__title--highlight">
              Weekly Munafa Intelligence
            </span>
          </h2>

          <p className="section-04__desc">
            Clear weekly decisions become easier when the process behind them
            stays simple. Here is how your salon&apos;s daily numbers turn into
            structured weekly clarity you can easily understand and actually use.
          </p>
        </div>

        <div className="section-04__image-wrapper">
          <img
            src={sectionImgMobile}
            alt="How Munafa Engine works - Mobile view"
            className="section-04__image-mobile"
            loading="lazy"
            decoding="async"
          />
          <img
            src={sectionImgDesktop}
            alt="How Munafa Engine works - Desktop view"
            className="section-04__image-desktop"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      {/* ── Steps ── */}
      <div className="section-04__steps">
        {steps.map((step) => (
          <div className="section-04__step-card" key={step.num}>
            <div className="section-04__step-left">
              <div
                className={`section-04__step-icon-circle section-04__step-icon-circle--${step.iconTheme}`}
              >
                {step.icon}
              </div>

              <div
                className={`section-04__step-num section-04__step-num--${step.iconTheme}`}
              >
                {step.num}
              </div>
            </div>

            <div className="section-04__step-body">
              <h3 className="section-04__step-title">{step.title}</h3>

              <div className="section-04__step-tags">
                {step.tags.map((tag, i) => (
                  <React.Fragment key={i}>
                    <span
                      className={`section-04__step-tag section-04__step-tag--${tag.color}`}
                    >
                      {tag.label}
                    </span>

                    {i < step.tags.length - 1 && (
                      <span className="section-04__step-tag-sep">|</span>
                    )}
                  </React.Fragment>
                ))}
              </div>

              <p className="section-04__step-desc">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Section04;